import { render, staticRenderFns } from "./PdfBookingLayoutSkeleton.vue?vue&type=template&id=780cca80&scoped=true&"
import script from "./PdfBookingLayoutSkeleton.vue?vue&type=script&lang=js&"
export * from "./PdfBookingLayoutSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PdfBookingLayoutSkeleton.vue?vue&type=style&index=0&id=780cca80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780cca80",
  null
  
)

export default component.exports